/**
 * An outbound link that degrades safely when its URL has not been set yet.
 *
 * With a URL it is an ordinary anchor that opens a new tab. Without one it
 * still renders and stays in the tab order, but it is marked unavailable and
 * does not navigate, so an unpublished store listing never sends anyone to a
 * dead page.
 */
export default function ExternalLink({
  href,
  children,
  newTabHint = false,
  ...rest
}) {
  const isLive = typeof href === 'string' && href.length > 0;

  return (
    <a
      href={isLive ? href : '#'}
      target={isLive ? '_blank' : undefined}
      rel={isLive ? 'noopener noreferrer' : undefined}
      aria-disabled={isLive ? undefined : 'true'}
      onClick={isLive ? undefined : (event) => event.preventDefault()}
      {...rest}
    >
      {children}
      {isLive && newTabHint ? (
        <span className="sr-only"> (opens in a new tab)</span>
      ) : null}
    </a>
  );
}
